import { AuthConfig } from 'angular-oauth2-oidc';

export type OAuthConfig = Pick<
  AuthConfig,
  | 'redirectUri'
  | 'clientId'
  | 'issuer'
  | 'loginUrl'
  | 'userinfoEndpoint'
  | 'tokenEndpoint'
> & {
  jwksUrl: string;
};

export const mergeOAuthConfig = (config: OAuthConfig): AuthConfig => {
  return {
    issuer: config.issuer,
    clientId: config.clientId,
    redirectUri: config.redirectUri,
    loginUrl: config.loginUrl,
    tokenEndpoint: config.tokenEndpoint,
    userinfoEndpoint: config.userinfoEndpoint,
    jwks: {
      url: config.jwksUrl,
    },
    responseType: 'code',
    scope: 'openid profile email',
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    sessionChecksEnabled: false,
  };
};
